/**
 * product-card-variant-price.js
 *
 * Updates [data-card-price], [data-card-compare-price] and
 * [data-card-savings-badge] inside a product-card when a colour swatch
 * radio is changed.
 *
 * Uses a direct delegated listener on document — works for all cards
 * regardless of when they were connected to the DOM.
 */

(function () {

  /**
   * Format cents into a currency string that matches Shopify's
   * money_without_trailing_zeros filter output (no non-breaking spaces).
   */
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })
      .format(cents / 100)
      .replace(/\u00A0/g, '')   // remove non-breaking spaces (Dutch/EU locale adds these)
      .replace(/\.00$/, '')     // strip .00
      .replace(/,00$/, '');     // strip ,00
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateCardPrice(card, variant) {
    var priceEl   = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare-price]');
    var badgeEl   = card.querySelector('[data-card-savings-badge]');

    if (!priceEl) return;

    var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    // ── Sale / regular price ─────────────────────────────────────────────────
    var srOnly = priceEl.querySelector('.sr-only');
    priceEl.textContent = formatMoney(variant.price);
    if (srOnly) priceEl.prepend(srOnly);

    if (isOnSale) {
      priceEl.classList.remove('text-subdued');
      priceEl.classList.add('text-on-sale');
    } else {
      priceEl.classList.remove('text-on-sale');
      priceEl.classList.add('text-subdued');
    }

    // ── Compare-at price ─────────────────────────────────────────────────────
    if (isOnSale) {
      if (!compareEl) {
        compareEl = document.createElement('compare-at-price');
        compareEl.className = 'text-subdued line-through';
        compareEl.setAttribute('data-card-compare-price', '');
        var srLabel = document.createElement('span');
        srLabel.className = 'sr-only';
        srLabel.textContent = 'Regular price';
        compareEl.appendChild(srLabel);
        priceEl.insertAdjacentElement('afterend', compareEl);
      }
      var srOnly2 = compareEl.querySelector('.sr-only');
      compareEl.textContent = formatMoney(variant.compare_at_price);
      if (srOnly2) compareEl.prepend(srOnly2);
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }

    // ── Savings badge (inside price-list, after compare-at price) ───────────
    if (isOnSale) {
      var savings = variant.compare_at_price - variant.price;
      var savingsText = formatMoney(savings);
var priceList = card.querySelector('.price-list');
var saveLabel = (priceList && priceList.getAttribute('data-save-label')) || 'Sparen';

      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'discount_badge';
        badgeEl.setAttribute('data-card-savings-badge', '');
        // Insert as first child of price-list so row-reverse places it rightmost visually
        var priceList = card.querySelector('.price-list');
        if (priceList) {
          priceList.insertAdjacentElement('afterbegin', badgeEl);
        }
      }

      badgeEl.textContent = saveLabel + ' ' + savingsText;
      badgeEl.style.display = '';
    } else if (badgeEl) {
      badgeEl.style.display = 'none';
    }
  }

  // Delegated listener — fires for every swatch radio change on any card
  document.addEventListener('change', function (event) {
    var radio = event.target;

    if (
      !radio.matches(
        '.product-card__swatch-list [type="radio"], ' +
        '.product-card__variant-list [type="radio"]'
      )
    ) return;

    var variantId = radio.getAttribute('data-variant-id');
    if (!variantId) return;

    var card = radio.closest('product-card');
    if (!card) return;

    var pricesScript = card.querySelector('[data-variant-prices]');
    if (!pricesScript) return;

    var prices;
    try {
      prices = JSON.parse(pricesScript.textContent);
    } catch (e) { return; }

    var variantData = prices.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variantData) return;

    updateCardPrice(card, variantData);
  });

})();
